import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import { Grid } from "@material-ui/core";

import { STEPPER_AUTORIZACIONES, TIPOS_AUTORIZACIONES } from "../../../utils/constants";

import {
  setActiveStep,
  cleanAfiliadoSeleccionado,
  clearReducer,
} from "../../../actions/autorizaciones/Autorizaciones";

import { AutorizacionesStepper } from "../UI/AutorizacionesStepper";
import { AutorizacionesBuscador } from "./AutorizacionesBuscador";
import { AutorizacionesAccordionHistorialConsumos } from "./Accordions/AutorizacionesAccordionHistorialConsumos";
import { AutorizacionesDatosTitular } from "./AutorizacionesDatosTitular";
import { AutorizacionesDetalleOrden } from "./AutorizacionesDetalleOrden";
import { AutorizacionesPracticas } from "./AutorizacionesPracticas";
import { AutorizacionesPresupuestos } from "./AutorizacionesPresupuestos";
import { AutorizacionesPracticasLaboratorio } from './AutorizacionesPracticasLaboratorio';
import { AutorizacionesConfirmacion } from './AutorizacionesConfirmacion';
import { AutorizacionesPracticasEstadoLaboratorio } from './AutorizacionesPracticasEstadoLaboratorio';

export const AutorizacionesIngresoHome = (props) => {
  const dispatch = useDispatch();
  const { activeStep = 0, solicitudSeleccionada, presupuestoSeleccionado } = useSelector((state) => state.autorizaciones);

  const cleanState = () => {
    dispatch(setActiveStep(STEPPER_AUTORIZACIONES.BUSCADOR));
    dispatch(cleanAfiliadoSeleccionado());
    dispatch(clearReducer());
  };

  useEffect(() => {
    if(!props.fromGestion)  cleanState();
  }, []);

  return (
    <React.Fragment>
      <Grid item xs={12}>
        <AutorizacionesStepper activeStep={activeStep} />
      </Grid>
      {activeStep === STEPPER_AUTORIZACIONES.DATOS_TITULAR && (
        <Grid item xs={12}>
          <AutorizacionesAccordionHistorialConsumos />
        </Grid>
      )}
      <Grid item xs={11}>
        {activeStep === STEPPER_AUTORIZACIONES.BUSCAR_TITULAR && (
          <AutorizacionesBuscador />
        )}
        {activeStep === STEPPER_AUTORIZACIONES.DATOS_TITULAR && (
          <AutorizacionesDatosTitular />
        )}
        {activeStep === STEPPER_AUTORIZACIONES.DETALLES_ORDEN && (
          <AutorizacionesDetalleOrden 
            permisoIngresoInterDom={props.permisoIngresoInterDom}
          />
        )}
        {activeStep === STEPPER_AUTORIZACIONES.PRACTICAS && (
          !solicitudSeleccionada && presupuestoSeleccionado
            ? <AutorizacionesPresupuestos />
            : solicitudSeleccionada?.idTipoSolicitud === TIPOS_AUTORIZACIONES.LABORATORIO
              ? <AutorizacionesPracticasLaboratorio />
              : <AutorizacionesPracticas permisoIngresoInterDom={props.permisoIngresoInterDom} />
        )}
        {activeStep === STEPPER_AUTORIZACIONES.CONFIRMACION && (
          solicitudSeleccionada?.idTipoSolicitud === TIPOS_AUTORIZACIONES.LABORATORIO
            ? <AutorizacionesPracticasEstadoLaboratorio />
            : <AutorizacionesConfirmacion />
        )}
      </Grid>

    </React.Fragment>
  );
};
